import { Directive, Host } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { debounceTime, fromEvent } from 'rxjs';

@UntilDestroy()
@Directive({
  selector: 'ngx-datatable[scResizeTable]',
  standalone: false
})
export class ResizeTableDirective {
  constructor(@Host() datatable: DatatableComponent) {
    fromEvent(window, 'resize')
      .pipe(untilDestroyed(this), debounceTime(250))
      .subscribe(() => {
        datatable.recalculate();
      });
  }
}
